import { hasClass } from './hasClass';
export function removeClass(el, str) {
  if (hasClass(el, str)) {
    el.className = el.className.replace(str, '');
  }
}


//////////////////
// WEBPACK FOOTER
// ../work/src/~/tiny-slider/src/helpers/removeClass.js
// module id = 45
// module chunks = 0